import { render, staticRenderFns } from "./UserCampaignsDialog.vue?vue&type=template&id=a1f858a0&scoped=true&"
import script from "./UserCampaignsDialog.vue?vue&type=script&lang=ts&"
export * from "./UserCampaignsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserCampaignsDialog.vue?vue&type=style&index=0&id=a1f858a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f858a0",
  null
  
)

export default component.exports